// extracted by mini-css-extract-plugin
export default {"share_container":"CfCommentForm_share_container__pKIaR","overlay":"CfCommentForm_overlay__q5lWZ"};